<div class="slider-control">
  <nz-slider
    class="slider-control__slider"
    [ngModel]="value()"
    (ngModelChange)="onSliderChange($event)"
    (nzOnAfterChange)="onSliderCommit()"
    [nzMin]="min()"
    [nzMax]="max()"
  />
  @if (showInput()) {
    <div class="slider-control__input-group">
      <nz-input-number
        [ngModel]="value()"
        (ngModelChange)="onInputChange($event)"
        [nzMin]="min()"
        [nzMax]="max()"
        [nzStep]="step()"
        [nzPrecision]="0"
      />
      @if (unit()) {
        <span>{{ unit() }}</span>
      }
    </div>
  }
</div>
